import { AppState } from '../rootReducer';
import { ErrorsState } from './types';

export const errorsSelectors = {
  getApiError: (state: AppState) => state.errors.apiError
};
